import { useLocation } from 'react-router-dom';
import { ButtonLink } from '@/components/ui/Button';
import styles from './StatusPages.module.css';
import { routes } from '@/lib/routePaths';

export default function NotFoundPage() {
  const location = useLocation();
  return <div className={styles.page}>
    <section className={styles.content}>
      <span className={styles.code}>404 · Not found</span>
      <h1>This page does not exist</h1>
      <p>The address may be outdated or the page may have moved.</p>
      <p className={styles.path}>{location.pathname}</p>
      <div className={styles.actions}><ButtonLink to={routes.overview}>Return to Overview</ButtonLink></div>
    </section>
  </div>;
}
